import React from 'react';

import { useNavigate, useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import InsuranceForm from './InsuranceForm';

import { useUiContext } from '../../../../context/UiContext';
import InsuranceService from '../../../../services/InsuranceService';

export default function AddOrEditInsurance({
  loanId,
  lenderId,
  isVisible,
  refetchLoan,
  readOnly,
}) {
  const { resourceId: insuranceId } = useParams();
  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { data: insurance, refetch } = useQuery({
    queryKey: ['insurance', insuranceId],
    queryFn: () => InsuranceService.getInsurance(insuranceId),
    enabled: !!insuranceId && insuranceId !== 'new',
  });

  const { showToast, showDialogModal } = useUiContext();

  const { mutate: removePolicyMutation } = useMutation({
    mutationFn: async (id) => {
      await InsuranceService.deleteInsurance(id);
      return id;
    },
    onSuccess: () => {
      showToast({
        text: 'Insurance policy deleted successfully',
        type: 'success',
      });

      if (loanId) {
        queryClient.invalidateQueries(['insurances', loanId]);
        navigate(`/loans/${loanId}?tab=Insurances`);
      } else if (lenderId) {
        queryClient.invalidateQueries(['lenderInsurances', lenderId]);
        navigate(`/lenders/${lenderId}?tab=Insurances`);
      }
    },
    onError: (error) => {
      console.log(error);
      showToast({
        text: error?.response?.data?.message || 'Something went wrong',
        type: 'error',
      });
    },
  });

  const removePolicy = (id) => {
    showDialogModal({
      title: 'Are you sure you want to delete this insurance policy?',
      type: 'danger',
      confirmButtonLabel: 'Yes, delete it',
      cancelButtonLabel: 'No, cancel',
      onConfirm: async () => {
        removePolicyMutation(id);
      },
    });
  };

  return (
    <div className="flex flex-col gap-12">
      <InsuranceForm
        isEdit={insuranceId !== 'new'}
        insurance={insurance}
        removePolicy={() => removePolicy(insuranceId)}
        loanId={loanId}
        lenderId={lenderId}
        isVisible={isVisible}
        readOnly={readOnly}
        refetchLoan={refetchLoan}
        refetchInsurance={refetch}
        insuranceId={insuranceId}
      />
    </div>
  );
}
